import "core-js/modules/es.function.name";

/*
  Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

  This software is the confidential and proprietary information of Wells Fargo
  bank. ('Confidential Information'). You shall not disclose such Confidential
  Information and shall use it only in accordance with the terms of the license
  agreement you entered into with WellsFargo.

  Author: Thomas Barry

  Description
  -----------
  Returns the nearest parent (or self) that has the specified attribute; returns
  undefined if no qualifying element is found.
*/
export var findParentWithAttribute = function findParentWithAttribute(attributeName) {
  return function (element) {
    if (element.hasAttribute(attributeName)) {
      return element;
    }

    var node = element.parentElement;

    while (node !== null) {
      if (node.hasAttribute && node.hasAttribute(attributeName)) {
        return node;
      }

      node = node.parentElement;
    }

    return undefined;
  };
};
export var hasParentWithAttribute = function hasParentWithAttribute(attributeName) {
  return function (element) {
    return typeof findParentWithAttribute(attributeName)(element) !== 'undefined';
  };
};
export var hasParentWithAttributeValue = function hasParentWithAttributeValue(_ref) {
  var name = _ref.name,
      value = _ref.value;
  return function (element) {
    var node = findParentWithAttribute(name)(element);

    if (typeof node !== 'undefined') {
      return value === node.getAttribute(name);
    }

    return false;
  };
};